<template>
  <el-dialog
    title="生成结算单"
    width="880px"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-table
      v-loading="loading"
      :data="data"
      style="width:100%"
      border
    >
      <el-table-column label="序号" type="index" width="60" align="center" />
      <el-table-column label="姓名" minWidth="120" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.name || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="身份证号" minWidth="180" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.idCard || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" minWidth="140" align="center">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="付款时间" minWidth="160" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.payTime || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="付款金额" minWidth="160" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.payAmt || "--" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <my-pagination
      :page-info="pageInfo"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    />
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">关 闭</el-button>
      <el-button size="small" type="primary" @click="handleDownload">下载结算单</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  pageByBill
} from "@/api/orderAdmin/orderList";
import { getAppUserInfo } from "@/api/common"
import { downloadData } from '@/api/common'
import myPagination from "@/components/myPagination.vue";

export default {
  name: 'BillEdList',

  components: { myPagination },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      filter: {
        balanceId: '',
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
    }
  },
  methods: {
    init (payload) {
      this.filter.balanceId = payload.id
      this.getOrderListPage({
        ...this.filter,
        ...this.pageInfo
      })
      this.dialogVisible = true
    },
    // 列表请求
    getOrderListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page
      this.pageInfo.limit = payload.limit
      pageByBill(payload).then(({ code, data }) => {
        if (code === 0) {
          this.data = data.records
          this.pageInfo.total = Number(data.total)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 下载
    handleDownload () {
      downloadData(
        `/order/adm/bill/exportBill`,
        { balanceId: this.filter.balanceId }
      )
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getOrderListPage({
        ...this.filter,
        page: payload,
        limit: this.pageInfo.limit
      })
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getOrderListPage({
        ...this.filter,
        page: 1, limit: payload
      })
    },
    handleClose () {
      this.filter = this.$options.data().filter
      this.pageInfo = this.$options.data().pageInfo
      this.data = []
      this.dialogVisible = false
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.data.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  }
}
</script>

<style>

</style>
